module.exports = __webpack_public_path__ + "static/media/xp.518b8fcd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Players/xp.svg
// module id = 181
// module chunks = 0